export default "__VITE_ASSET__C27FFPM8__"